export default {
  INACTIVITY_TIMEOUT: {
    ENABLED: true, // Enable inactivity timeout
    TIMEOUT: 30 * 60 * 1000, // 30 minutes
    INTERVAL: 1 * 60 * 1000, // 1 minute
  },
};
